import { useQuery } from "react-query";

import { residualsCommonService } from "services";
import { EnumDto } from "types";

type UseSourceOfDataQueryProps = {
	options?: any;
};

const useSourceOfDataQuery = ({ options }: UseSourceOfDataQueryProps = {}) =>
	useQuery("sourceOfData", residualsCommonService.getSourceTypes, {
		select: (data: EnumDto[]) =>
			data?.sort((firstValue, nextValue) =>
				firstValue.displayName > nextValue.displayName ? 1 : -1,
			),
		...options,
	});

export default useSourceOfDataQuery;
